<span class="badge"><ng-content></ng-content></span>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/badge/badge.html